import {ICON_TYPES} from '../constants';

export const HamburgerIcon = (): JSX.Element => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_2977_1869)'>
        <path d='M24 11.0006H0V13.0006H24V11.0006Z' fill='#141414' />
        <path d='M24 4.00024H0V6.00024H24V4.00024Z' fill='#141414' />
        <path d='M24 18H0V20H24V18Z' fill='#141414' />
      </g>
      <defs>
        <clipPath id='clip0_2977_1869'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

HamburgerIcon.iconType = ICON_TYPES.HAMBURGER;
